import type { FaireThemeEntity } from "../../entity_types/theme";

export const modern_host_home_gifts: FaireThemeEntity = {
  token: "modern-host-home-gifts",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Modern Host & Home Gifts",
  description: "Elevated hostess gifts \u2014 a growing category for you",
  bgColor: "#F5F0D4",
  tileBgColor: "#7e6833",
  productTokens: [
    "p_e3bdrm2455",
    "p_fhn7dp8kvx",
    "p_vx3uhppt3k",
    "p_c8vh57hqjm",
    "p_fs87xaj2tm",
    "p_rqphvbyymx",
    "p_rwyazu5t5u",
    "p_b66ftcnywr",
    "p_fazcexhkjs",
    "p_7r568xa26n",
    "p_sgbxxmm8ut",
    "p_nxve7pnej7",
    "p_s9nrbjccsu",
    "p_42twguuyyx",
    "p_tsyjmkxkq4",
    "p_prxeovi8ya",
    "p_5ktbtpqmu8",
    "p_g6ywte78vr",
    "p_nfnnmh5hv4",
    "p_fvtrfv3y4c",
    "p_9h9vr3hj3w",
    "p_d6afnuhy79",
    "p_ehuubstvwj",
    "p_d9yk2es9us",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
